
<Card class="max-w-448 mx-auto">
  <h1 class="text-h2 centered my-24">How often will <span class="linebreak">you need care?</span></h1>
  <form>
    <Card
      :clickable="true"
      @click="selectSchedule(ScheduleTypes.REGULAR)"
      class="w-full mb-12 !p-0"
      :selected="selectedSchedule === ScheduleTypes.REGULAR"
    >
      <div class="flex flex-row gap-8 items-center">
        <RegularScheduleIcon />
        <div class="flex flex-col gap-6">
          <h3 class="text-strong-body">Regular sitter</h3>
          <p class="text-small">Weekly, before/after school, driving</p>
        </div>
      </div>
    </Card>

    <Card
      :clickable="true"
      @click="selectSchedule(ScheduleTypes.ONE_TIME)"
      class="w-full mb-12 !p-0"
      :selected="selectedSchedule === ScheduleTypes.ONE_TIME"
    >
      <div class="flex flex-row gap-8 items-center">
        <OneTimeScheduleIcon />
        <div class="flex flex-col gap-6">
          <h3 class="text-strong-body">One-time sitter</h3>
          <p class="text-small">Date night, upcoming event, backup</p>
        </div>
      </div>
    </Card>

    <Card
      :clickable="true"
      @click="selectSchedule(ScheduleTypes.OCCASIONAL)"
      class="w-full mb-12 !p-0"
      :selected="selectedSchedule === ScheduleTypes.OCCASIONAL"
    >
      <div class="flex flex-row gap-8 items-center">
        <OccasionalScheduleIcon />
        <div class="flex flex-col gap-6">
          <h3 class="text-strong-body">Occasional sitter</h3>
          <p class="text-small">As-needed for when you need care</p>
        </div>
      </div>
    </Card>

    <Card
      :clickable="true"
      @click="selectSchedule(ScheduleTypes.NANNY)"
      class="w-full mb-12 !p-0"
      :selected="selectedSchedule === ScheduleTypes.NANNY"
    >
      <div class="flex flex-row gap-8 items-center">
        <NannyScheduleIcon />
        <div class="flex flex-col gap-6">
          <h3 class="text-strong-body">Nanny</h3>
          <p class="text-small">Ongoing, usually 2-5 full weekdays</p>
        </div>
      </div>
    </Card>

    <HelperText v-if="errors.selectSchedule" :text="errors.selectSchedule" :status="HelperStatus.Error" />

    <div class="flex flex-row-reverse mt-24">
      <RouteStepperNextButton :draftData="draftData" :validate="validate" @errors="errors = $event" />
    </div>
  </form>
</Card>
